import { noticeFailure, noticeSuccess } from "@self/notices";
import { makeStylesheetLink } from "@self/stylesheet";
import { genId } from "@self/utils";

export class ApplyGiftCard extends HTMLElement {

	shadow: ShadowRoot;

	input: HTMLInputElement;
	button: HTMLButtonElement;

	static get observedAttributes() {
		return ["value"] as const;
	}

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = (
			<button
				type="button"
				className="gct-btn-lg gct-btn-secondary"
			>
				Apply
			</button>
		) as HTMLButtonElement;

		const id = genId();

		this.input = <input
			id={id}
			type="text"
			className="gct-w100"
			value={this.getAttribute("value") ?? ""}
			placeholder=" "
		/> as HTMLInputElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			<div className="gct-flex-row gct-gap-16 gct-flex-space-between gct-w100">
				<div className="gct-p-relative gct-flex-grow">
					{this.input}
					<label htmlFor={id} className="gct-input-label">Gift card code</label>
				</div>
				{this.button}
			</div>,
			makeStylesheetLink(),
		);
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: ApplyGiftCard) {
	try {
		this.button.disabled = true;
		this.input.disabled = true;

		this.button.disabled = true;
		this.input.disabled = true;

		const giftCardCode = this.input.value;

		const data = new URLSearchParams({
			action: "apply_gift_card_to_session",
			security: this.dataset.nonce!,
			wc_gc_cart_code: giftCardCode,
			wc_gc_is_checkout: "true",
		});

		const res = await fetch(this.dataset.endpoint!, {
			method: "POST",
			body: data,
		});

		const json = await res.json();

		if (json === null || typeof json !== "object" || !("result" in json) || !("applied" in json) || !("notices_html" in json) || typeof json.notices_html !== "string") {
			noticeFailure("There was an unexpected error.");
			return;
		} else {
			const notices = new DOMParser().parseFromString(json.notices_html, "text/html");
			const noticeText = notices.documentElement.textContent ?? "";
			(json.applied === "yes" ? noticeSuccess : noticeFailure)(noticeText);
		}
	} catch (error) {
		if (error instanceof TypeError) {
			noticeFailure("Couldn't connect. Are you online?");
		} else {
			noticeFailure("There was an unexpected error.")
		}
	} finally {
		this.button.disabled = false;
		this.input.disabled = false;
	}
}
